/* PRISKEL — Build Your Own Stack. Picking, live totals, mobile bar, curated add/edit. */
(function () {
  function money(p) { return '₹' + Math.round(p / 100).toLocaleString('en-IN'); }
  function payOf(sub, pct) { return Math.floor(sub * (100 - pct) / 10000) * 100; }
  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function addItems(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add'); return j; }); });
  }
  function preapply(code) { if (code) try { fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {}); } catch (e) {} }

  function init(root) {
    if (root.__pk) return; root.__pk = 1;
    var t2 = +root.getAttribute('data-t2') || 0, t3 = +root.getAttribute('data-t3') || 0;
    var code = root.getAttribute('data-code') || '';
    var want = +root.getAttribute('data-mode') || 3;
    var grid = root.querySelector('[data-pk-by-grid]');
    var slots = [].slice.call(root.querySelectorAll('[data-pk-by-slot]'));
    var addBtn = root.querySelector('[data-pk-by-add]');
    var bar = root.querySelector('[data-pk-by-bar]');
    var chosen = [];
    var o = function (k) { return root.querySelector('[data-pk-by-o="' + k + '"]'); };

    function items() { return [].slice.call(grid.querySelectorAll('[data-pk-by-item]')); }
    function read(item) {
      var sel = item.querySelector('[data-pk-by-var]');
      var opt = sel.tagName === 'SELECT' ? sel.options[sel.selectedIndex] : sel;
      var price = +opt.getAttribute('data-price') || 0, mrp = +opt.getAttribute('data-mrp') || price;
      return { id: +sel.value, price: price, mrp: Math.max(mrp, price), title: item.getAttribute('data-title'), img: item.getAttribute('data-img'), item: item };
    }
    function byVariant(id) {
      var hit = null;
      items().forEach(function (it) {
        if (hit) return;
        var sel = it.querySelector('[data-pk-by-var]');
        if (sel.tagName === 'SELECT') {
          for (var i = 0; i < sel.options.length; i++) if (+sel.options[i].value === id) { sel.selectedIndex = i; hit = it; }
        } else if (+sel.value === id) hit = it;
      });
      return hit;
    }

    function paint() {
      var n = chosen.length, sub = 0, mrp = 0;
      chosen.forEach(function (c) { sub += c.price; mrp += c.mrp; });
      var pct = n >= 3 ? t3 : n === 2 ? t2 : 0;
      var pay = pct ? payOf(sub, pct) : sub;
      var save = mrp - pay;
      slots.forEach(function (s, i) {
        var c = chosen[i];
        s.hidden = i >= want;
        s.classList.toggle('is-full', !!c);
        s.classList.toggle('is-next', !c && i === n);
        s.querySelector('[data-pk-by-slot-im]').innerHTML = c && c.img ? '<img src="' + esc(c.img) + '" alt="" width="100" height="125">' : '';
        s.querySelector('[data-pk-by-slot-t]').textContent = c ? c.title : (i === n ? 'Choose a piece' : 'Empty');
      });
      root.querySelectorAll('[data-pk-by-mode]').forEach(function (b) { b.setAttribute('aria-checked', +b.getAttribute('data-pk-by-mode') === want ? 'true' : 'false'); });
      o('mrp').textContent = money(mrp);
      o('sub').textContent = money(sub);
      o('pct').textContent = pct ? pct + '%' : '';
      o('extra').textContent = pct ? '−' + money(sub - pay) : '—';
      o('pay').textContent = money(pay);
      o('you').innerHTML = n && save > 0 ? 'You save <b>' + money(save) + '</b> (' + Math.floor(save * 100 / mrp) + '% off MRP)' : '';
      var left = want - n, hint;
      if (!n) hint = 'Add ' + want + ' pieces to unlock ' + (want === 3 ? t3 : t2) + '% off.';
      else if (left > 0) hint = left === 1 ? 'One more piece unlocks ' + (want === 3 ? t3 : t2) + '% off.' : 'Two more to go.';
      else if (want === 2) hint = t2 + '% off unlocked. Add a third for ' + t3 + '%.';
      else hint = t3 + '% off unlocked. Our best stack price.';
      root.querySelector('[data-pk-by-hint]').textContent = hint;
      root.querySelector('[data-pk-by-meter]').style.width = Math.min(100, n / want * 100) + '%';
      var complete = n === want;
      addBtn.disabled = !complete;
      root.querySelector('[data-pk-by-add-l]').textContent = complete ? 'Add stack · ' + money(pay) : (left === 1 ? 'Pick 1 more piece' : 'Pick ' + left + ' more pieces');
      var ids = chosen.map(function (c) { return c.item; });
      items().forEach(function (it) {
        var on = ids.indexOf(it) > -1;
        it.classList.toggle('is-picked', on);
        it.querySelector('[data-pk-by-pick]').setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      grid.classList.toggle('is-full', complete);
      if (bar) {
        var bs = '';
        for (var i = 0; i < want; i++) bs += chosen[i] ? '<i><img src="' + esc(chosen[i].img) + '" alt=""></i>' : '<i></i>';
        bar.querySelector('[data-pk-by-bar-slots]').innerHTML = bs;
        bar.querySelector('[data-pk-by-bar-pay]').textContent = money(pay);
        bar.querySelector('[data-pk-by-bar-l]').textContent = complete ? (pct + '% off · save ' + money(save)) : (n + ' of ' + want + ' picked');
        var go = bar.querySelector('[data-pk-by-bar-go]');
        go.disabled = !complete;
        go.textContent = complete ? 'Add stack' : 'Pick ' + left + ' more';
      }
    }

    function pulse(el) { if (!el || reduce) return; el.classList.remove('is-pulse'); void el.offsetWidth; el.classList.add('is-pulse'); }

    function toggle(item) {
      var at = -1;
      chosen.forEach(function (c, i) { if (c.item === item) at = i; });
      if (at > -1) { chosen.splice(at, 1); paint(); return; }
      if (chosen.length >= want) {
        if (want === 2) { want = 3; }
        else { var h = root.querySelector('[data-pk-by-hint]'); h.textContent = 'Your stack is full. Remove a piece to swap it.'; pulse(root.querySelector('[data-pk-by-panel]')); return; }
      }
      chosen.push(read(item));
      paint();
      pulse(slots[chosen.length - 1]);
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      var pick = t.closest('[data-pk-by-pick]');
      if (pick) { toggle(pick.closest('[data-pk-by-item]')); return; }
      var m = t.closest('[data-pk-by-mode]');
      if (m) { want = +m.getAttribute('data-pk-by-mode'); if (chosen.length > want) chosen = chosen.slice(0, want); paint(); return; }
      var x = t.closest('[data-pk-by-clear]');
      if (x) { var i = slots.indexOf(x.closest('[data-pk-by-slot]')); if (chosen[i]) { chosen.splice(i, 1); paint(); } return; }
      var f = t.closest('[data-pk-by-filter]');
      if (f) {
        var v = f.getAttribute('data-pk-by-filter');
        root.querySelectorAll('[data-pk-by-filter]').forEach(function (b) { b.setAttribute('aria-pressed', b === f ? 'true' : 'false'); });
        items().forEach(function (it) { it.hidden = v !== '*' && it.getAttribute('data-type') !== v; });
        return;
      }
      if (t.closest('[data-pk-by-bar-go]')) { addBtn.click(); return; }
      var set = t.closest('[data-pk-by-addset]');
      if (set) {
        var ids = set.getAttribute('data-pk-by-addset').split(',').filter(Boolean).map(function (id) { return { id: +id, quantity: 1 }; });
        run(set, ids); return;
      }
      var ed = t.closest('[data-pk-by-edit]');
      if (ed) {
        var vids = ed.getAttribute('data-pk-by-edit').split(',').filter(Boolean).map(Number);
        chosen = [];
        want = vids.length >= 3 ? 3 : 2;
        root.querySelectorAll('[data-pk-by-filter]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-pk-by-filter') === '*' ? 'true' : 'false'); });
        items().forEach(function (it) { it.hidden = false; });
        vids.forEach(function (id) { var it = byVariant(id); if (it) chosen.push(read(it)); });
        paint();
        var b = root.querySelector('#pk-by-build');
        if (b) b.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }
    });

    root.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-pk-by-var]');
      if (!sel) return;
      var item = sel.closest('[data-pk-by-item]');
      var opt = sel.options[sel.selectedIndex];
      var pr = item.querySelector('[data-pk-by-price]');
      if (pr) pr.textContent = money(+opt.getAttribute('data-price'));
      chosen.forEach(function (c, i) { if (c.item === item) chosen[i] = read(item); });
      paint();
    });

    function run(btn, list) {
      if (!list.length) return;
      var l = btn.querySelector('[data-pk-by-add-l]') || btn, was = l.textContent;
      btn.disabled = true; l.textContent = 'Adding…';
      addItems(list).then(function () {
        preapply(code);
        l.textContent = 'Added to bag';
        if (window.PKCart && window.PKCart.open) window.PKCart.open();
        setTimeout(function () { btn.disabled = false; l.textContent = was; paint(); }, 2200);
      }).catch(function (err) {
        l.textContent = (err && err.message) || 'Try again';
        setTimeout(function () { btn.disabled = false; l.textContent = was; paint(); }, 2600);
      });
    }
    addBtn.addEventListener('click', function () {
      if (chosen.length !== want) return;
      run(addBtn, chosen.map(function (c) { return { id: c.id, quantity: 1 }; }));
    });

    /* mobile bar: only while the builder is on screen and the panel isn't */
    if (bar && 'IntersectionObserver' in window) {
      var inBuild = false, panelSeen = false;
      var sync = function () { var on = inBuild && !panelSeen; bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); bar.querySelector('[data-pk-by-bar-go]').tabIndex = on ? 0 : -1; };
      new IntersectionObserver(function (en) { inBuild = en[0].isIntersecting; sync(); }, { rootMargin: '-30% 0px -10% 0px' }).observe(grid);
      new IntersectionObserver(function (en) { panelSeen = en[0].isIntersecting; sync(); }, { threshold: .25 }).observe(root.querySelector('[data-pk-by-panel]'));
    }
    paint();
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-pk-by]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 50); });
})();
